import $i18n from '../../../../lang/index';

export const headerList = [
  {
    id: 1,
    label: $i18n.t('navbar.siteName'),
    prop: 'siteName',
    cloWidth: 150,
    center: 'center'
  },
  {
    id: 2,
    label: $i18n.t('customerManagements.AccountName'),
    prop: 'userName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 3,
    label: $i18n.t('collectionCenter.theDriverName'),
    prop: 'realName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 4,
    label: $i18n.t('receivablePayable.deliveryVehicleType'),
    prop: 'deliveryVehicleTypeName',
    cloWidth: 160,
    center: 'center'
  },
  // 邀请码
  {
    id: 5,
    label: $i18n.t('seller.invitationCode'),
    prop: 'code',
    cloWidth: 150,
    center: 'center'
  },
  {
    id: 6,
    label: $i18n.t('seller.expirationTime'),
    prop: 'expiringTime',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 7,
    label: $i18n.t('Resource.schedule'),
    prop: 'progressName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 9,
    label: $i18n.t('collectionCenter.processingResult'),
    prop: 'handleResultName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 99,
    label: $i18n.t('seller.auditRejectionReason'),
    prop: 'failReason',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 10,
    label: $i18n.t('collectionCenter.carType'),
    prop: 'vehicleType',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 11,
    label: $i18n.t('GlobalSetObj.CreatePeople'),
    prop: 'createUserName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 12,
    label: $i18n.t('GlobalSetObj.CreationTime'),
    prop: 'createTime',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 13,
    label: $i18n.t('seller.documentReviewTime'),
    prop: 'submitTime',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 14,
    label: $i18n.t('GlobalSetObj.LatestProcessor'),
    prop: 'updateUserName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 15,
    label: $i18n.t('GlobalSetObj.LatestProcessingTime'),
    prop: 'updateTime',
    cloWidth: 160,
    center: 'center'
  }
];
